// Keep in sync with src/api/config/tiers.ts
export const TIER_LIMITS = {
  free: 100,
  supporter: 250,
  pro: 1000,
  enterprise: 10000,
} as const;

export const ADMIN_EMAIL_DOMAIN = "@pinnacleridgesolutions.com";

export const ROUTES = {
  HOME: "/",
  DATA_COVERAGE: "/data-coverage",
  LOGIN: "/login",
  VERIFY: "/verify",
  DASHBOARD: "/dashboard",
  KEYS: "/dashboard/keys",
  BILLING: "/dashboard/billing",
  SUBMISSIONS: "/dashboard/submissions/new",
  SUPPORT: "/dashboard/support",
  BILLING_SUCCESS: "/billing/success",
  BILLING_CANCEL: "/billing/cancel",
  DOCS: "/docs",
  ADMIN: "/admin",
  ADMIN_USERS: "/admin",
  ADMIN_ABUSE: "/admin/abuse",
  ADMIN_USER_DETAIL: "/admin/users",
  ADMIN_SUBSCRIPTIONS: "/admin/subscriptions",
  ADMIN_USAGE: "/admin/usage",
  ADMIN_LOGS: "/admin/logs",
  ADMIN_ENTERPRISE: "/admin/enterprise",
  ADMIN_WINE_HEALTH: "/admin/wine-health",
  ADMIN_PROVIDER_STATUS: "/admin/provider-status",
  ADMIN_API_TESTS: "/admin/api-tests",
  CONTACT_ENTERPRISE: "/contact-enterprise",
  TERMS: "/terms",
  PRIVACY: "/privacy",
  MCP: "/mcp-setup",
} as const;
